import React from 'react';

import { Tag } from 'antd';

import type { IOtaStepProgress } from '../api/getOtaExecutionHistory';
import { OTA_STEP_NAME, OTA_STEP_STATUS } from '../types';

interface IBoxOtaStepCounterProps {
  steps: IOtaStepProgress[];
  isExpanded: boolean;
}

export const BoxOtaStepCounter = ({
  steps,
  isExpanded,
}: IBoxOtaStepCounterProps) => {
  if (isExpanded) return null;

  const filteredSteps = steps.filter((s) => s.step !== OTA_STEP_NAME.END);
  const { completedCount, hasInProgress, hasPending } = filteredSteps.reduce(
    (acc, s) => ({
      completedCount:
        acc.completedCount + (s.status === OTA_STEP_STATUS.COMPLETED ? 1 : 0),
      hasInProgress:
        acc.hasInProgress || s.status === OTA_STEP_STATUS.IN_PROGRESS,
      hasPending: acc.hasPending || s.status === OTA_STEP_STATUS.PENDING,
    }),
    { completedCount: 0, hasInProgress: false, hasPending: false }
  );
  const currentStep = completedCount + (hasInProgress || hasPending ? 1 : 0);

  return (
    <Tag data-testid="ota-step-counter">
      {currentStep}/{filteredSteps.length}
    </Tag>
  );
};
